import './rxjs-extensions';

import { NgModule } from '@angular/core';
import { FormsModule,ReactiveFormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';

import { PasswordComponent } from './password.component';
import { PasswordRoutingModule } from './password.routing.module';

import { GenericdatasetService } from '../../services/genericdataset/genericdataset.service';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    PasswordRoutingModule,
    ReactiveFormsModule
  ],
  exports: [
    PasswordComponent
  ],
  declarations: [
    PasswordComponent
  ],
  providers: [
    GenericdatasetService
  ],
})
export class PasswordModule { }
